// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg
				viewBox="0 0 18 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M5.81909 6.70469C4.8094 6.9918 4.13159 7.83125 4.2019 8.73086C4.52253 8.38359 5.0119 8.08281 5.60534 7.88594L5.81909 6.70469ZM2.6944 8.06641L1.80284 3.1582C1.7944 3.11445 1.81128 3.08711 1.80846 3.08438C3.43409 2.20664 5.27065 1.74453 7.12409 1.74453C7.16909 1.74453 7.21409 1.75 7.2619 1.75C7.65565 1.38086 8.15346 1.12656 8.71315 1.03906C9.24471 0.957031 9.78471 0.913281 10.3219 0.894141C10.0407 0.511328 9.63284 0.232422 9.14628 0.155859C8.47409 0.0519531 7.79628 0 7.12409 0C4.96971 0 2.84065 0.530469 0.933776 1.56133C0.253151 1.92773 -0.109662 2.69336 0.0309634 3.46172L0.922526 8.36992C1.3219 10.5711 4.75596 12.2555 6.67409 12.2555C6.77534 12.2555 6.86534 12.2418 6.95534 12.2336C6.57565 11.766 6.14253 11.1262 5.8444 10.3852C4.50565 10.0297 2.86034 8.97422 2.69721 8.06641H2.6944ZM5.4394 4.30664C5.41971 4.19453 5.37753 4.09063 5.32409 3.99492C5.09065 4.23828 4.7419 4.42695 4.33128 4.49531C3.91784 4.56641 3.52409 4.50625 3.22034 4.35313C3.20628 4.45977 3.20346 4.57188 3.22315 4.68398C3.33003 5.27734 3.91503 5.67383 4.52534 5.56992C5.13846 5.46602 5.54628 4.9 5.43659 4.30664H5.4394ZM17.0663 3.30586C14.5631 1.95508 11.6832 1.46289 8.85378 1.90039C8.08596 2.0207 7.47284 2.61953 7.33502 3.38789L6.44346 8.29609C6.01034 10.6777 9.12378 13.6637 10.8956 13.9672C12.6675 14.2707 16.6472 12.4961 17.0803 10.1172L17.9719 5.20898C18.1125 4.44063 17.7469 3.675 17.0663 3.30859V3.30586ZM9.38253 5.95273C9.4894 5.35938 10.0744 4.96289 10.6847 5.0668C11.2978 5.1707 11.7057 5.73672 11.5988 6.33008C11.5791 6.44219 11.5369 6.54609 11.4835 6.6418C11.25 6.39844 10.9013 6.20977 10.4907 6.14141C10.0772 6.07031 9.68346 6.13047 9.37971 6.28359C9.36565 6.17422 9.36003 6.06484 9.38253 5.95273ZM11.3653 11.3887C9.79878 11.1207 8.73565 9.76719 8.86221 8.30156C9.44159 8.99883 10.4428 9.56484 11.6607 9.77266C12.8785 9.98047 14.0175 9.78359 14.8078 9.31875C14.4085 10.7379 12.9319 11.6566 11.3653 11.3887ZM15.03 7.25156C14.7966 7.0082 14.4478 6.81953 14.0372 6.75117C13.6238 6.68008 13.23 6.74023 12.9263 6.89336C12.9122 6.78672 12.9094 6.67461 12.9291 6.5625C13.036 5.96914 13.621 5.57266 14.2313 5.67656C14.8444 5.78047 15.2522 6.34648 15.1453 6.93984C15.1257 7.05195 15.0835 7.15586 15.03 7.25156Z"
					fill="#FF0202"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
